import { useCallback } from "react";
import { apiNiches } from "@/common/services";
import { usePaginatedFeed } from "@/common/hooks/usePaginatedFeed";

interface IProps {
  order: string;
  query?: string;
  verified?: boolean;
  tags?: string;
  category?: string;
}

export const useSearchNichesPreviews = ({ order, query, tags, category }: IProps) => {
  const request = useCallback((page?: number) => {
    return apiNiches.searchNichesPreviews({
      order,
      count: 30,
      query,
      tags,
      category: category === "All" ? undefined : category,
      page: page || 1,
    });
  }, [order, query, tags, category]);

  const feed = usePaginatedFeed(["nichesPreviewsGifs", order, query, tags, category], request);

  return { feed };
};
